export class FailedToAddToContainerError extends Error {    
    constructor(...params) {
        // @ts-ignore
        super(...params)

        this.name = "FailedToAddToContainerError"
    }
}
